/* ============================================================
   HEUREUX SHOPIFY THEME — theme.js
   All JS: Preloader, Cursor, Navbar, Particles, Tabs,
           Stats Counter, Quote Modal, Form Validation
   ============================================================ */

(function () {
  'use strict';

  /* ── PRELOADER ───────────────────────────────────────────── */
  var preloader = document.getElementById('preloader');
  var preloaderBar = document.getElementById('preloaderBar');
  var preloaderPct = document.getElementById('preloaderPct');
  var appWrapper = document.getElementById('appWrapper');

  function dismissPreloader() {
    if (preloader && preloader.style.display !== 'none') {
      preloader.style.opacity = '0';
      preloader.style.transition = 'opacity 0.4s ease';
      setTimeout(function () {
        preloader.style.display = 'none';
      }, 400);
    }
    if (appWrapper) {
      appWrapper.style.opacity = '1';
      appWrapper.style.transition = 'opacity 0.4s ease';
    }
  }

  var progress = 0;
  var preloaderInterval = setInterval(function () {
    progress += Math.random() * 20 + 8;
    if (progress >= 100) {
      progress = 100;
      clearInterval(preloaderInterval);
      setTimeout(dismissPreloader, 200);
    }
    var pct = Math.min(Math.round(progress), 100);
    if (preloaderBar) preloaderBar.style.width = pct + '%';
    if (preloaderPct) preloaderPct.textContent = pct + '%';
  }, 100);

  // Safety guarantee: always reveal page within 1.8s max
  setTimeout(function () {
    clearInterval(preloaderInterval);
    dismissPreloader();
  }, 1800);

  /* ── CUSTOM CURSOR ───────────────────────────────────────── */
  var cursorDot = document.getElementById('cursorDot');
  var cursorRing = document.getElementById('cursorRing');

  if (cursorDot && cursorRing && window.innerWidth > 920) {
    document.addEventListener('mousemove', function (e) {
      cursorDot.style.left = e.clientX + 'px';
      cursorDot.style.top = e.clientY + 'px';
      cursorRing.style.left = e.clientX + 'px';
      cursorRing.style.top = e.clientY + 'px';
    });

    document.querySelectorAll('a, button, [data-hover]').forEach(function (el) {
      el.addEventListener('mouseenter', function () { cursorRing.classList.add('hovered'); });
      el.addEventListener('mouseleave', function () { cursorRing.classList.remove('hovered'); });
    });
  }

  /* ── NAVBAR SCROLL ───────────────────────────────────────── */
  var navbar = document.getElementById('navbar');
  if (navbar) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 60) {
        navbar.classList.add('navbar-scrolled');
      } else {
        navbar.classList.remove('navbar-scrolled');
      }
    }, { passive: true });
  }

  /* ── HAMBURGER MOBILE MENU ───────────────────────────────── */
  var hamburger = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobileMenu');
  var menuOpen = false;

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      menuOpen = !menuOpen;
      mobileMenu.classList.toggle('mobile-menu-open', menuOpen);
      hamburger.innerHTML = menuOpen
        ? '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>'
        : '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';
    });
  }

  /* ── SMOOTH SCROLL NAV LINKS ─────────────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      if (href && href.length > 1) {
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
          if (mobileMenu) mobileMenu.classList.remove('mobile-menu-open');
          menuOpen = false;
        }
      }
    });
  });

  /* ── HERO PARTICLE CANVAS ─────────────────────────────────── */
  var canvas = document.getElementById('heroCanvas');
  if (canvas) {
    var ctx = canvas.getContext('2d');
    var particles = [];

    function resizeCanvas() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas, { passive: true });

    for (var i = 0; i < 70; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 1.4 + 0.4,
        vx: (Math.random() - 0.5) * 0.28,
        vy: (Math.random() - 0.5) * 0.28,
        alpha: Math.random() * 0.5 + 0.1
      });
    }

    function drawParticles() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(function (p) {
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0) p.x = canvas.width;
        if (p.x > canvas.width) p.x = 0;
        if (p.y < 0) p.y = canvas.height;
        if (p.y > canvas.height) p.y = 0;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(33,199,255,' + p.alpha + ')';
        ctx.fill();
      });

      for (var a = 0; a < particles.length; a++) {
        for (var b = a + 1; b < particles.length; b++) {
          var dx = particles[a].x - particles[b].x;
          var dy = particles[a].y - particles[b].y;
          var dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 110) {
            ctx.beginPath();
            ctx.moveTo(particles[a].x, particles[a].y);
            ctx.lineTo(particles[b].x, particles[b].y);
            ctx.strokeStyle = 'rgba(33,199,255,' + (0.055 * (1 - dist / 110)) + ')';
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        }
      }
      requestAnimationFrame(drawParticles);
    }
    drawParticles();
  }

  /* ── STATS COUNTER ANIMATION ─────────────────────────────── */
  function animateCounter(el, target) {
    var start = 0;
    var duration = 1800;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var ease = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(ease * target).toLocaleString();
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var statNumbers = document.querySelectorAll('.stat-number[data-target]');
  if (statNumbers.length && 'IntersectionObserver' in window) {
    var statsObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.getAttribute('data-target'), 10);
          animateCounter(el, target);
          statsObserver.unobserve(el);
        }
      });
    }, { threshold: 0.4 });

    statNumbers.forEach(function (el) { statsObserver.observe(el); });
  }

  /* ── PRODUCT TABS ─────────────────────────────────────────── */
var prodTabs = document.querySelectorAll('.prod-tab');

  var tabPanels = document.querySelectorAll('.tab-content-panel');

  var defaultProdTab = 'led-screens';

 

  function activateProdTab(tabName) {

    prodTabs.forEach(function (t) {

      if (t.getAttribute('data-tab') === tabName) {

        t.classList.add('prod-tab-active');

      } else {

        t.classList.remove('prod-tab-active');

      }

    });

 

    tabPanels.forEach(function (panel) {

      if (panel.getAttribute('data-panel') === tabName) {

        panel.style.display = 'block';

        panel.style.animation = 'fadeUp 0.4s ease';

      } else {

        panel.style.display = 'none';

      }

    });

  }

 

  prodTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      activateProdTab(this.getAttribute('data-tab'));
    });
  });

  /* ── COLLAPSIBLE PRODUCT SPECIFICATIONS ─────────────────────── */
  function initProductSpecsCollapsible() {
    var grids = document.querySelectorAll('.prod-feature-grid');
    grids.forEach(function (grid) {
      if (grid.parentElement && grid.parentElement.classList.contains('prod-specs-collapsible')) {
        return;
      }
      var wrapper = document.createElement('div');
      wrapper.className = 'prod-specs-collapsible';

      var toggleBtn = document.createElement('button');
      toggleBtn.type = 'button';
      toggleBtn.className = 'prod-specs-toggle';
      toggleBtn.setAttribute('aria-expanded', 'false');
      toggleBtn.innerHTML = '<span>Key Specifications</span><svg class="specs-chevron" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';

      toggleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
        var card = toggleBtn.closest('.prod-card');
        var infoSection = toggleBtn.closest('.prod-info-section');
        if (isOpen) {
          toggleBtn.setAttribute('aria-expanded', 'false');
          toggleBtn.classList.remove('active');
          wrapper.classList.remove('is-open');
          if (card) card.classList.remove('is-expanded');
          if (infoSection) infoSection.classList.remove('is-expanded');
        } else {
          toggleBtn.setAttribute('aria-expanded', 'true');
          toggleBtn.classList.add('active');
          wrapper.classList.add('is-open');
          if (card) card.classList.add('is-expanded');
          if (infoSection) infoSection.classList.add('is-expanded');
        }
      });

      grid.parentNode.insertBefore(toggleBtn, grid);
      wrapper.appendChild(grid);
      toggleBtn.parentNode.insertBefore(wrapper, toggleBtn.nextSibling);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSpecsCollapsible);
  } else {
    initProductSpecsCollapsible();
  }

 

  if (prodTabs.length) {

    activateProdTab(defaultProdTab);

  }

  /* ── QUOTE MODAL ─────────────────────────────────────────── */
  window.openQuoteModal = function (productName) {
    var modal = document.getElementById('quoteModal');
    if (modal) {
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      if (typeof productName === 'string' && productName) {
        var prodSelect = document.getElementById('q-product');
        if (prodSelect) {
          var targetLower = productName.toLowerCase();
          for (var i = 0; i < prodSelect.options.length; i++) {
            var optText = prodSelect.options[i].text.toLowerCase();
            var optVal = prodSelect.options[i].value.toLowerCase();
            if (optText.indexOf(targetLower) !== -1 || targetLower.indexOf(optText) !== -1 ||
                optVal.indexOf(targetLower) !== -1 || targetLower.indexOf(optVal) !== -1) {
              prodSelect.selectedIndex = i;
              break;
            }
          }
        }
      }
    }
  };

  window.closeQuoteModal = function () {
    var modal = document.getElementById('quoteModal');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  };

  // Wire all quote buttons
  var quoteButtons = [
    document.getElementById('navQuoteBtn'),
    document.getElementById('mobileQuoteBtn'),
    document.getElementById('heroQuoteBtn'),
    document.getElementById('footerQuoteBtn')
  ];
  quoteButtons.forEach(function (btn) {
    if (btn) btn.addEventListener('click', window.openQuoteModal);
  });

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.closeQuoteModal();
  });

  /* ── QUOTE FORM VALIDATION & SUBMIT ──────────────────────── */
  window.submitQuoteForm = function (e) {
    e.preventDefault();

    var name = document.getElementById('q-name');
    var mobile = document.getElementById('q-mobile');
    var email = document.getElementById('q-email');
    var product = document.getElementById('q-product');

    var errors = {};
    if (!name || !name.value.trim()) errors.name = 'Name is required';
    if (!mobile || !/^[6-9]\d{9}$/.test(mobile.value.trim())) errors.mobile = 'Enter a valid 10-digit mobile number';
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) errors.email = 'Enter a valid email address';
    if (!product || !product.value) errors.product = 'Please select a product';

    // Clear previous errors
    ['name', 'mobile', 'email', 'product'].forEach(function (field) {
      var grp = document.getElementById('grp-' + field);
      var err = document.getElementById('err-' + field);
      if (grp) grp.classList.remove('has-error');
      if (err) err.textContent = '';
    });

    // Show errors
    var hasErrors = false;
    Object.keys(errors).forEach(function (field) {
      hasErrors = true;
      var grp = document.getElementById('grp-' + field);
      var err = document.getElementById('err-' + field);
      if (grp) grp.classList.add('has-error');
      if (err) err.textContent = errors[field];
    });

    if (hasErrors) return;

    // Show loading
    var submitBtn = document.getElementById('quoteSubmitBtn');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span class="spinner"></span> Sending...';
    }

    // Submit to Shopify contact form endpoint
    var formData = new FormData();
    formData.append('form_type', 'contact');
    formData.append('utf8', '✓');
    formData.append('contact[name]', name ? name.value.trim() : '');
    formData.append('contact[email]', email ? email.value.trim() : '');
    formData.append('contact[phone]', mobile ? mobile.value.trim() : '');
    formData.append('contact[body]',
      'Product: ' + (product ? product.value : '') + '\n' +
      'Mobile: ' + (mobile ? mobile.value.trim() : '') + '\n' +
      'Company: ' + (document.getElementById('q-company') ? document.getElementById('q-company').value : '') + '\n' +
      'Message: ' + (document.getElementById('q-message') ? document.getElementById('q-message').value : '')
    );

    fetch('/contact', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function () {
      showQuoteSuccess(name.value.trim(), product ? product.value : '');
    })
    .catch(function () {
      // Still show success - form data captured
      showQuoteSuccess(name ? name.value.trim() : '', product ? product.value : '');
    });
  };

  function showQuoteSuccess(name, productName) {
    var form = document.getElementById('quoteForm');
    var success = document.getElementById('quoteSuccess');
    var msg = document.getElementById('successMsg');
    if (form) form.style.display = 'none';
    if (success) success.style.display = 'flex';
    if (msg) msg.innerHTML = 'Thank you, <strong>' + name + '</strong>! We\'ve received your request for <strong>' + productName + '</strong>. Our team will contact you within 24 hours.';
  }

  /* ── SCROLL REVEAL ANIMATION ─────────────────────────────── */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    var revealEls = document.querySelectorAll(
      '.stat-card, .about-card, .prod-card, .why-card, .usecase-card, .cert-card, .trust-card, .it-service-card, .soft-card, .sector-card'
    );
    revealEls.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(28px)';
      el.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
      revealObserver.observe(el);
    });
  }

  /* ── ABOUT CARD SHINE EFFECT ─────────────────────────────── */
  document.querySelectorAll('.about-card').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      card.style.setProperty('--touch-x', x + '%');
      card.style.setProperty('--touch-y', y + '%');
    });
  });

  /* ── SOFTWARES TAB FILTER LOGIC ───────────────────────────── */
  var softTabs = document.querySelectorAll('.soft-tab');
  var softCards = document.querySelectorAll('.soft-card');

  function applySoftwareFilter(filter) {
    if (filter === 'all') {
      softCards.forEach(function (card) {
        card.style.display = '';
        card.classList.remove('soft-card-filtered-out');
        card.classList.remove('soft-card-highlighted');
      });
    } else {
      softCards.forEach(function (card) {
        var cat = card.getAttribute('data-category');
        if (cat === filter) {
          card.style.display = '';
          card.classList.remove('soft-card-filtered-out');
          card.classList.add('soft-card-highlighted');
        } else {
          card.style.display = 'none';
          card.classList.add('soft-card-filtered-out');
          card.classList.remove('soft-card-highlighted');
        }
      });
    }
  }

  if (softTabs.length > 0) {
    var initialActive = document.querySelector('.soft-tab.active');
    if (initialActive) {
      applySoftwareFilter(initialActive.getAttribute('data-filter'));
    }

    softTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var filter = this.getAttribute('data-filter');

        softTabs.forEach(function (t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');

        applySoftwareFilter(filter);
      });
    });
  }

  /* ── INDUSTRIAL CUSTOMIZABLE DASHBOARD SWITCHER ─────────── */
  var idashBtns = document.querySelectorAll('.idash-mode-btn');
  var idashTitle = document.getElementById('idashFrameTitle');
  var idashTable = document.getElementById('idashMetricsTable');

  var idashModes = {
    ehs: {
      title: 'EHS DASHBOARD',
      rows: [
        { icon: '🛡️', label: 'ACCIDENT FREE DAYS', val: '128', color: 'val-green' },
        { icon: '⚠️', label: 'NEAR MISS REPORTED', val: '02', color: 'val-amber' },
        { icon: '👤', label: 'LTI (LOST TIME INJURY)', val: '00', color: 'val-red' },
        { icon: '👨‍🏫', label: 'TRAINING COMPLIANCE', val: '98%', color: 'val-gold' }
      ]
    },
    oee: {
      title: 'PRODUCTION & OEE DASHBOARD',
      rows: [
        { icon: '🏭', label: 'LINE 04 ASSEMBLY TARGET', val: '1,200', color: 'val-cyan' },
        { icon: '📦', label: 'ACTUAL SHIFT OUTPUT', val: '1,148', color: 'val-green' },
        { icon: '⚡', label: 'OVERALL OEE EFFICIENCY', val: '95.6%', color: 'val-gold' },
        { icon: '⏱️', label: 'UNPLANNED DOWNTIME', val: '00 MIN', color: 'val-green' }
      ]
    },
    precautions: {
      title: 'SAFETY PRECAUTIONS DASHBOARD',
      rows: [
        { icon: '🦺', label: 'MANDATORY PPE COMPLIANCE', val: '100%', color: 'val-green' },
        { icon: '🧯', label: 'FIRE & HAZARD READINESS', val: 'VERIFIED', color: 'val-green' },
        { icon: '🚨', label: 'EMERGENCY EVACUATION EXITS', val: 'CLEAR', color: 'val-cyan' },
        { icon: '⚠️', label: 'LOCKOUT / TAGOUT PROTOCOL', val: 'ENGAGED', color: 'val-amber' }
      ]
    }
  };

  if (idashBtns.length > 0 && idashTable) {
    idashBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = this.getAttribute('data-idash-mode');
        var data = idashModes[mode];
        if (!data) return;

        idashBtns.forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');

        if (idashTitle) idashTitle.textContent = data.title;

        var html = '';
        data.rows.forEach(function (r) {
          html += '<div class="idash-row">' +
            '<div class="idash-label-group">' +
              '<span class="idash-icon">' + r.icon + '</span>' +
              '<span class="idash-label">' + r.label + '</span>' +
            '</div>' +
            '<span class="idash-val ' + r.color + '">' + r.val + '</span>' +
          '</div>';
        });
        idashTable.innerHTML = html;
      });
    });
  }

  var liveClockEl = document.getElementById('idashLiveClock');
  if (liveClockEl) {
    function updatePlantClock() {
      var now = new Date();
      var timeStr = now.toLocaleTimeString('en-US', { hour12: true });
      liveClockEl.textContent = '⏰ ' + timeStr;
    }
    updatePlantClock();
    setInterval(updatePlantClock, 1000);
  }

  /* ── ACTIVE NAV LINK ON SCROLL ───────────────────────────── */
  var sections = document.querySelectorAll('section[id]');
  var navLinks = document.querySelectorAll('.nav-link');

  window.addEventListener('scroll', function () {
    var scrollY = window.scrollY + 120;
    sections.forEach(function (section) {
      var top = section.offsetTop;
      var height = section.offsetHeight;
      var id = section.getAttribute('id');
      if (scrollY >= top && scrollY < top + height) {
        navLinks.forEach(function (link) {
          link.classList.remove('active');
          if (link.getAttribute('href') === '#' + id) {
            link.classList.add('active');
          }
        });
      }
    });
  }, { passive: true });

  /* ── SECTOR PIE CHART CONTROLLER (With Auto-Cycling Animation) ── */
  var sectorData = [
    {
      name: "Education",
      tag: "Smart Classrooms & 4K IFPs",
      hint: "Interactive Sector 1 of 8",
      accent: "#21c7ff",
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>'
    },
    {
      name: "Corporate Offices",
      tag: "Boardrooms & Video Calling",
      hint: "Interactive Sector 2 of 8",
      accent: "#7c3aed",
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="16" height="20" x="4" y="2" rx="2" ry="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01"/><path d="M16 6h.01"/><path d="M12 6h.01"/><path d="M12 10h.01"/><path d="M12 14h.01"/><path d="M16 10h.01"/><path d="M16 14h.01"/><path d="M8 10h.01"/><path d="M8 14h.01"/></svg>'
    },
    {
      name: "Healthcare",
      tag: "Clinical & Patient Displays",
      hint: "Interactive Sector 3 of 8",
      accent: "#00d2ff",
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>'
    },
    {
      name: "Retail & Malls",
      tag: "Digital Standees & Signage",
      hint: "Interactive Sector 4 of 8",
      accent: "#ec4899",
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>'
    },
    {
      name: "Stadiums & Events",
      tag: "Massive Arena LED Screens",
      hint: "Interactive Sector 5 of 8",
      accent: "#f59e0b",
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>'
    },
    {
      name: "Airports & Transport",
      tag: "Flight Boards & Wayfinding",
      hint: "Interactive Sector 6 of 8",
      accent: "#3b82f6",
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"/></svg>'
    },
    {
      name: "Hospitality",
      tag: "Luxury Lobbies & Menus",
      hint: "Interactive Sector 7 of 8",
      accent: "#a855f7",
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>'
    },
    {
      name: "Government & PSUs",
      tag: "BIS-Compliant Smart City LED",
      hint: "Interactive Sector 8 of 8",
      accent: "#10b981",
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" x2="21" y1="22" y2="22"/><line x1="6" x2="6" y1="18" y2="11"/><line x1="10" x2="10" y1="18" y2="11"/><line x1="14" x2="14" y1="18" y2="11"/><line x1="18" x2="18" y1="18" y2="11"/><polygon points="12 2 20 7 4 7"/></svg>'
    }
  ];

  var activeSectorIdx = 0;
  var isSectorPaused = false;
  var sectorCycleInterval = null;

  var sliceGroups = document.querySelectorAll('.pie-slice-group');
  var coreTitle = document.getElementById('coreTitle');
  var coreTag = document.getElementById('coreTag');
  var coreHint = document.querySelector('.core-hint');
  var coreIconBox = document.getElementById('coreIconBox');

  function setActiveSector(idx) {
    if (idx < 0 || idx >= sectorData.length) return;
    activeSectorIdx = idx;
    var data = sectorData[idx];

    // Update SVG slice groups
    sliceGroups.forEach(function (grp, i) {
      if (i === idx) {
        grp.classList.add('pie-slice-active');
      } else {
        grp.classList.remove('pie-slice-active');
      }
    });

    // Update center core
    if (coreTitle) coreTitle.textContent = data.name;
    if (coreTag) coreTag.textContent = data.tag;
    if (coreHint) coreHint.textContent = data.hint;
    if (coreIconBox) {
      coreIconBox.innerHTML = data.iconSvg;
      coreIconBox.style.color = data.accent;
      coreIconBox.style.borderColor = data.accent;
      coreIconBox.style.boxShadow = '0 10px 26px ' + data.accent + '40';
    }
  }

  // Automatic cycling rotation animation (advances every 3.2s)
  function startSectorAutoCycle() {
    if (sectorCycleInterval) clearInterval(sectorCycleInterval);
    sectorCycleInterval = setInterval(function () {
      if (!isSectorPaused) {
        var nextIdx = (activeSectorIdx + 1) % sectorData.length;
        setActiveSector(nextIdx);
      }
    }, 3200);
  }

  // Pause on hover over pie wheel
  var wheelStage = document.getElementById('pieWheelStage');

  if (wheelStage) {
    wheelStage.addEventListener('mouseenter', function () { isSectorPaused = true; });
    wheelStage.addEventListener('mouseleave', function () { isSectorPaused = false; });
  }

  // Bind slice hover and click events
  sliceGroups.forEach(function (grp) {
    var idx = parseInt(grp.getAttribute('data-index'), 10);
    grp.addEventListener('mouseenter', function () { setActiveSector(idx); });
    grp.addEventListener('click', function () { setActiveSector(idx); });
  });

  startSectorAutoCycle();

  /* ── MOBILE SOFTWARES FEATURE TOGGLE ──────────────────────── */
  function initMobileSoftwaresFeatures() {
    var standardCards = document.querySelectorAll('#software-classroom-ai, #software-parking, #software-industrial');
    standardCards.forEach(function (card) {
      var interactiveCol = card.querySelector('.soft-card-interactive-col');
      var mainCol = card.querySelector('.soft-card-main-col');
      if (!interactiveCol || !mainCol) return;
      if (mainCol.querySelector('.soft-features-toggle')) return;

      var toggleBtn = document.createElement('button');
      toggleBtn.type = 'button';
      toggleBtn.className = 'soft-features-toggle';
      toggleBtn.setAttribute('aria-expanded', 'false');
      toggleBtn.innerHTML = '<span>View Features &amp; Live Console</span><svg class="features-chevron" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';

      toggleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          toggleBtn.setAttribute('aria-expanded', 'false');
          toggleBtn.classList.remove('active');
          interactiveCol.classList.remove('is-open');
        } else {
          toggleBtn.setAttribute('aria-expanded', 'true');
          toggleBtn.classList.add('active');
          interactiveCol.classList.add('is-open');
        }
      });

      mainCol.appendChild(toggleBtn);
    });

    var cmdCard = document.querySelector('#software-cmd');
    if (cmdCard && !cmdCard.querySelector('.soft-features-toggle')) {
      var pillars = cmdCard.querySelector('.cmd-pillars-grid');
      var sectors = cmdCard.querySelector('.cmd-sectors-block');
      var coreDesc = cmdCard.querySelector('.cmd-core-desc-box');

      if (pillars && sectors && coreDesc) {
        var cmdCollapsible = document.createElement('div');
        cmdCollapsible.className = 'cmd-mobile-collapsible';

        var toggleBtn = document.createElement('button');
        toggleBtn.type = 'button';
        toggleBtn.className = 'soft-features-toggle';
        toggleBtn.setAttribute('aria-expanded', 'false');
        toggleBtn.innerHTML = '<span>View Pillars &amp; 12 Sectors</span><svg class="features-chevron" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';

        toggleBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            toggleBtn.setAttribute('aria-expanded', 'false');
            toggleBtn.classList.remove('active');
            cmdCollapsible.classList.remove('is-open');
          } else {
            toggleBtn.setAttribute('aria-expanded', 'true');
            toggleBtn.classList.add('active');
            cmdCollapsible.classList.add('is-open');
          }
        });

        coreDesc.parentNode.insertBefore(toggleBtn, coreDesc.nextSibling);
        toggleBtn.parentNode.insertBefore(cmdCollapsible, toggleBtn.nextSibling);
        cmdCollapsible.appendChild(pillars);
        cmdCollapsible.appendChild(sectors);
      }
    }
  }

  initMobileSoftwaresFeatures();

})();
